import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            component: resolve => require(['@/page/Home'], resolve),
            index: 0,
            children: [{
                path: '',
                component: resolve => require(['@/page/Index/Index'], resolve),
                meta: {
                    title: '首页'
                }
            }, {
                path: '/class',
                component: resolve => require(['@/page/Class/Class'], resolve),
                meta: {
                    title: '分类',
                    index: 1
                }
            }, {
                path: '/shopcar',
                component: resolve => require(['@/page/ShopCar/ShopCar'], resolve),
                meta: {
                    title: '购物车',
                    index: 2
                }
            }, {
                path: '/order',
                component: resolve => require(['@/page/Order/Order'], resolve),
                meta: {
                    title: '采购单',
                    index: 3
                }
            }]
        },
        {
            path: '/login',
            name: '登录',
            component: resolve => require(['@/page/Login'], resolve)
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js